import StartEventHook from './StartEventHook'
import Logger from '../Log'
import { bidderForCode, getCcpa, getCmp, getTopUrl, isSecure, topmostWindowFrame } from '../utils'
import FillManager from '../FillManager'
import OutbrainFillMethod from '../fillers/OutbrainFillMethod'

const Log = Logger.for('OutbrainHook')

export default class OutbrainStartHook extends StartEventHook {
  constructor () {
    super('OutbrainHook')
  }

  async run (remoteConfig) {
    const bidder = bidderForCode('outbrain', remoteConfig.bidders(), true)
    if (!bidder) return

    const cmp = await getCmp()
    Log.debug('Got CMP data')
    const ccpa = await getCcpa()
    Log.debug('Got CMP data')

    const p = bidder.params = Object.assign(
      {
        key: 'SMART2BBEN0HABM3N6BJALENK',
        va: true,
        secured: isSecure(),
        contentUrl: getTopUrl(),
        t: null, /* client must fill out later if making multiple reqs */
        cors: true,
        format: 'vjnc',
        cnsnt: cmp ? cmp.consentData : null,
        ccpa: ccpa ? ccpa.uspString : null
      },
      bidder.params)

    if (!p.widgetJSId) {
      return Log.warn('Outbrain bidder enabled but no widgetJSId parameter, skipping')
    }

    const frame = topmostWindowFrame()
    const WINDOW_KEY = '_smrtb_ob_idx'

    if (isNaN(frame[WINDOW_KEY]) || frame[WINDOW_KEY] < p.idx) {
      frame[WINDOW_KEY] = p.idx
    }

    if (isNaN(p.idx)) {
      let idx = frame[WINDOW_KEY]

      if (isNaN(idx)) {
        Log.debug('Idx value not set or found, defaulting to 0')
        p.idx = frame[WINDOW_KEY] = 0
      } else {
        p.idx = idx = frame[WINDOW_KEY] += 1
        Log.debug('Idx value not set, using local available idx value ' + idx)
      }
    }

    FillManager.register(new OutbrainFillMethod(bidder))
    Log.debug('Outbrain fill method registered')
  }
}
